import { render } from "./ImageStep.vue?vue&type=template&id=965f72ae&scoped=true"
import script from "./ImageStep.vue?vue&type=script&lang=js"
export * from "./ImageStep.vue?vue&type=script&lang=js"

import "./ImageStep.vue?vue&type=style&index=0&id=965f72ae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-965f72ae"

export default script